import { formatDate, isJson } from '@/@core/utils/utils'

export const getTemplate3 = (
  report: any,
  reportValue: any,
  reportsVariants: any[],
  reportsVariantsType: any,
  samples: any[],
  specialInheritance: any[],
  t: any
) => {
  const switchGender = (gender: string) => {
    switch (gender) {
      case 'mother':
        return t('mother')
      case 'father':
        return t('father')
      case 'affected_child':
        return t('proband')
    }
  }

  return [
    {
      type: 'block-title',
      children: [
        {
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },
    {
      type: 'header2-genetic',
      children: [
        {
          text: '基因分析报告'
        }
      ]
    },
    {
      type: 'header3-genetic',
      children: [
        {
          text: '基本信息：'
        }
      ]
    },
    {
      type: 'block-patient-info',
      children: [
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `受检者`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [{ text: `${reportValue.patient?.patientName ?? '-'}` }]
        },
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `性别`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [
            {
              text: `${t((reportValue?.patient?.gender as string) ?? '-')}`
            }
          ]
        },
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `年龄`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [
            {
              text: `${
                reportValue.patient?.dateOfBirth
                  ? (Math.floor(
                      (new Date().valueOf() -
                        new Date(reportValue.patient?.dateOfBirth).valueOf()) /
                        3.15576e10
                    ) <= 0
                      ? 0
                      : Math.floor(
                          (new Date().valueOf() -
                            new Date(
                              reportValue.patient?.dateOfBirth
                            ).valueOf()) /
                            3.15576e10
                        )) + '岁'
                  : '-'
              }`
            }
          ]
        },
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `病案号`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [
            {
              text: `${reportValue.sample?.id ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `样本类型`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [
            {
              text: `${reportValue?.sample?.vcfType?.toLocaleUpperCase()}`
            }
          ]
        },
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `检测项目`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [
            {
              text: `${reportValue?.patient?.infirmaryName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `采样日期`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [
            {
              text: `${formatDate(reportValue.patient?.receiveDate) ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `检测日期`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [
            {
              text: `${formatDate(reportValue.sample?.annotatedStart) ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key',
          children: [
            {
              text: `报告日期`
            }
          ]
        },
        {
          type: 'p3-genetic-value',
          children: [
            {
              text: `${formatDate(report?.createdAt) ?? '-'}`
            }
          ]
        }
      ]
    },
    {
      type: 'header3-genetic',
      children: [
        {
          text: '临床表型信息：'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic',
              children: [{ text: '受检者' }]
            },
            {
              type: 'table-cell-color-genetic',
              children: [{ text: '姓名' }]
            },
            {
              type: 'table-cell-color-genetic',
              children: [{ text: '性别' }]
            },
            {
              type: 'table-cell-color-genetic',
              children: [{ text: '年龄' }]
            },
            {
              type: 'table-cell-color-genetic',
              children: [{ text: '临床特征(由受检者或临床医师提供)' }]
            }
          ]
        },
        ...samples.map((row) => {
          let arr = []

          if (row && row.sample) {
            const terms = row.sample.terms

            if (terms && isJson(terms)) {
              arr = JSON.parse(terms)
            } else if (Array.isArray(terms)) arr = terms
          }

          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p7',
                    children: [
                      {
                        text: row.patient?.patientName ?? '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p7',
                    children: [
                      {
                        text: row.patient?.patientName ?? '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p7',
                    children: [
                      {
                        text: t(row.patient?.gender ?? '-')
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p7',
                    children: [
                      {
                        text: `${
                          row.patient?.dateOfBirth
                            ? (Math.floor(
                                (new Date().valueOf() -
                                  new Date(
                                    row.patient?.dateOfBirth
                                  ).valueOf()) /
                                  3.15576e10
                              ) <= 0
                                ? 0
                                : Math.floor(
                                    (new Date().valueOf() -
                                      new Date(
                                        row.patient?.dateOfBirth
                                      ).valueOf()) /
                                      3.15576e10
                                  )) + '岁'
                            : '-'
                        }`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p7',
                    children: [
                      {
                        text:
                          arr && arr.length
                            ? arr
                                .flat()
                                .map(
                                  (item: any) =>
                                    `${item.name_cn}(${item.hpo_code})`
                                )
                                .join(';')
                            : '正常无表型'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'h4-genetic',
      children: [
        {
          text: `标准化后的HPO表型词：`
        }
      ]
    },

    {
      type: 'span',
      children: [
        {
          text: samples
            .map((items) => {
              if (items && items.sample) {
                const terms = items.sample.terms

                if (terms && isJson(terms)) {
                  return JSON.parse(terms)
                } else if (Array.isArray(terms)) return terms

                return []
              }

              return []
            })
            .flat()
            .map((item) => `${item.name_cn}(${item.hpo_code})`)
            .join(';')
        }
      ]
    },
    {
      type: 'h3-genetic',
      children: [
        {
          text: `一、检测分析结论：${
            report?.result === 'positive' ? '阳性' : '阴性'
          }`
        }
      ]
    },
    {
      type: 'h4-genetic',
      children: [
        {
          text: `1.1.CNV/SV/UPD检测分析结论`
        }
      ]
    },
    {
      type: 'p5',
      children: [
        {
          text: `染色体非整倍体分析：染色体组成4 6,XX，染色体数目正常`
        }
      ]
    },
    {
      type: 'p5',
      children: [
        {
          text: `染色体微缺失或微重复分析:`
        }
      ]
    },
    {
      type: 'p6',
      children: [
        {
          text: `本检测范围内，未发现与患者疾病相关性较高的CNV致病变异`
        }
      ]
    },
    {
      type: 'h3-genetic',
      children: [
        {
          text: `二、检测分析结论解读`
        }
      ]
    },
    {
      type: 'h4-genetic',
      children: [
        {
          text: `2.1.CNV/SV/UPD检测结果`
        }
      ]
    },
    {
      type: 'h5-genetic',
      children: [
        {
          text: `2.1.1.染色体数目图谱:`
        }
      ]
    },

    ...samples
      .filter((sample) => sample.plotAllData)
      .map((sample, index) => {
        return {
          type: 'block-gls-footer',
          children: [
            {
              type: 'p3-center',
              children: [
                {
                  text: `图${index + 1} ${
                    switchGender(sample.sample.type) ?? '-'
                  }(${t(sample.sample.gender)},患者)全基因组检测结果图`
                }
              ]
            },
            {
              type: 'image',
              children: [
                {
                  text: ``
                }
              ],
              url: sample.plotAllData
            }
          ]
        }
      }),
    {
      type: 'h4-genetic',
      children: [
        {
          text: `2.2.SNV检测结果`
        }
      ]
    },
    {
      type: 'h5-genetic',
      children: [
        {
          text: `2.2.1.致病证据不充分，但不排除致病可能的变异`
        }
      ]
    },
    {
      type: 'h5-genetic',
      children: [
        {
          text: `主要发现疾病描述：`
        }
      ]
    },
    ...reportsVariants
      .filter((item) => item.variantsType === 'KeyFinding')
      .map((row) => {
        return {
          type: 'block-gls-footer',
          children: [
            {
              type: 'table-available',
              children: [
                {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell-color-genetic',
                      children: [{ text: '基因' }]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [{ text: '序号' }]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '染色体'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '位置'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '核酸改变'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(外显子号)'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '氨基酸改变'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(变体号) '
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: 'RS号'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: 'MAF'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: 'ACMG致病'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '等级'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '先证者'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(女)'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '父'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(正常)'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '母'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(正常)'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '相关疾病(OMIM号)'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '遗传方式'
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: row.gene ?? '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: `chr${row.chrom}:${row.pos}` ?? '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: `${row.c_nomen}(${row.var_location})${row.nuc_change}`
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: row.rs_id ?? '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: row.user_acmg_classification
                                ? row.user_acmg_classification
                                    ?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : row.ACMG_classification
                                ? row.ACMG_classification?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : row.classification
                                ? row.classification
                                    ?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text:
                                row.allele_frequency &&
                                row.allele_frequency !== '.'
                                  ? row.allele_frequency < 0.85
                                    ? t('heterozygote')
                                    : t('homozygote')
                                  : '无'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text:
                                row.dad_allele_frequency &&
                                row.dad_allele_frequency !== '.'
                                  ? row.dad_allele_frequency < 0.85
                                    ? t('heterozygote')
                                    : t('homozygote')
                                  : '无'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text:
                                row.mom_allele_frequency &&
                                row.mom_allele_frequency !== '.'
                                  ? row.mom_allele_frequency < 0.85
                                    ? t('heterozygote')
                                    : t('homozygote')
                                  : '无'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              type: 'p5-genetic-value',
                              children: [
                                {
                                  text: row.OMIMCN ?? '-'
                                }
                              ]
                            },
                            {
                              type: 'p5-genetic-value',
                              children: [
                                {
                                  text: row.OMIM?.geneMim
                                    ? `OMIM ID: ${row.OMIM?.geneMim}`
                                    : ''
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'paragraph',
              children:
                row.OMIMData && row.OMIMData.length
                  ? row.OMIMData?.map((i: any) => {
                      return {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `${i.pheno_name_cn ?? '-'}`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            text: `${
                              i?.phenoClinicalFeaturesCNStr?.join('\n') ??
                              t('No Results')
                            }`
                          }
                        ]
                      }
                    })
                  : [{ text: '' }]
            }
          ]
        }
      }),
    {
      type: 'h5-genetic',
      children: [
        {
          text: `次要发现疾病描述：`
        }
      ]
    },

    ...reportsVariants
      .filter((item) => item.variantsType !== 'KeyFinding')
      .map((row) => {
        return {
          type: 'block-gls-footer',
          children: [
            {
              type: 'table-available',
              children: [
                {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell-color-genetic',
                      children: [{ text: '基因' }]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [{ text: '序号' }]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '染色体'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '位置'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '核酸改变'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(外显子号)'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '氨基酸改变'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(变体号) '
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: 'RS号'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: 'MAF'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: 'ACMG致病'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '等级'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '先证者'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(女)'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '父'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(正常)'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '母'
                            }
                          ]
                        },
                        {
                          type: 'p4-center',
                          children: [
                            {
                              text: '(正常)'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-color-genetic',
                      children: [
                        {
                          type: 'p4-center',
                          children: [
                            {
                              type: 'p4-center',
                              children: [
                                {
                                  text: '相关疾病(OMIM号)'
                                }
                              ]
                            },
                            {
                              type: 'p4-center',
                              children: [
                                {
                                  text: '遗传方式'
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-row',
                  children: [
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: row.gene ?? '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: `${row.chrom}:${row.pos}` ?? '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: ``
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: row.rs_id ?? '-'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text: row.user_acmg_classification
                                ? row.user_acmg_classification
                                    ?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : row.ACMG_classification
                                ? row.ACMG_classification?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : row.classification
                                ? row.classification
                                    ?.split(' ')
                                    .map((word: string) => {
                                      if (word.includes('Uncertain'))
                                        return `VU`
                                      if (word.includes('uncertain'))
                                        return `VU`
                                      if (word.includes('null')) return ``
                                      else return word[0].toUpperCase()
                                    })
                                    .join('')
                                : ''
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text:
                                row.allele_frequency &&
                                row.allele_frequency !== '.'
                                  ? row.allele_frequency < 0.85
                                    ? t('heterozygote')
                                    : t('homozygote')
                                  : '无'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text:
                                row.dad_allele_frequency &&
                                row.dad_allele_frequency !== '.'
                                  ? row.dad_allele_frequency < 0.85
                                    ? t('heterozygote')
                                    : t('homozygote')
                                  : '无'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              text:
                                row.mom_allele_frequency &&
                                row.mom_allele_frequency !== '.'
                                  ? row.mom_allele_frequency < 0.85
                                    ? t('heterozygote')
                                    : t('homozygote')
                                  : '无'
                            }
                          ]
                        }
                      ]
                    },
                    {
                      type: 'table-cell-genetic',
                      children: [
                        {
                          type: 'p5-genetic-value',
                          children: [
                            {
                              type: 'p4-genetic-value',
                              children: [
                                {
                                  text: row.OMIMCN ?? '-'
                                }
                              ]
                            },
                            {
                              type: 'p5-genetic-value',
                              children: [
                                {
                                  text: row.OMIM?.geneMim
                                    ? `OMIM ID: ${row.OMIM?.geneMim}`
                                    : ''
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'paragraph',
              children:
                row.OMIMData && row.OMIMData.length
                  ? row.OMIMData?.map((i: any) => {
                      return {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `${i.pheno_name_cn ?? '-'}`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            text: `${
                              i?.phenoClinicalFeaturesCNStr?.join('\n') ??
                              t('No Results')
                            }`
                          }
                        ]
                      }
                    })
                  : [
                      {
                        text: ''
                      }
                    ]
            }
          ]
        }
      }),
    {
      type: 'h3-genetic',
      children: [
        {
          text: `三、检测项目信息`
        }
      ]
    },
    {
      type: 'block-patient-info',
      children: [
        {
          type: 'p3-genetic-key-33',
          children: [
            {
              text: `检测项目`
            }
          ]
        },
        {
          type: 'p3-genetic-value-66',
          children: [
            {
              text: `家系三人全基因组测序(trioWGS)30X测序分析`
            }
          ]
        },
        {
          type: 'p3-genetic-key-33',
          children: [
            {
              text: `检测方法`
            }
          ]
        },
        {
          type: 'p3-genetic-value-66',
          children: [
            {
              text: `全基因组高通量测序`
            }
          ]
        },
        {
          type: 'p3-genetic-key-33',
          children: [
            {
              text: `检测区域* `
            }
          ]
        },
        {
          type: 'p3-genetic-value-66',
          children: [
            {
              text: `人类基因组2万个基因的全基因组区(包含非编码区和UTR调控区)`
            }
          ]
        },
        {
          type: 'p3-genetic-key-33',
          children: [
            {
              text: `检测策略`
            }
          ]
        },
        {
          type: 'p3-genetic-value-66',
          children: [
            {
              text: `针对受检者临床及所选分析项目，分析OMIM，MedGen等数据库已报道的疾病`
            }
          ]
        },
        {
          type: 'p3-genetic-key-33',
          children: [
            {
              text: `检测目的 `
            }
          ]
        },
        {
          type: 'p3-genetic-value-66',
          children: [
            {
              text: `查找遗传病因，辅助临床精准诊断，指导精准治疗和遗传咨询`
            }
          ]
        },
        {
          type: 'p3-genetic-key-33',
          children: [
            {
              text: `捕获探针信息 `
            }
          ]
        },
        {
          type: 'p3-genetic-value-66',
          children: [
            {
              text: `IDT-51M/WGS`
            }
          ]
        }
      ]
    },
    {
      type: 'h3-genetic',
      children: [
        {
          text: `四、测序数据质控`
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '姓名' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-c2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: 'WGS' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '>10X覆盖度（%）' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: 'Q30' }]
                }
              ]
            }
          ]
        },
        ...samples.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.patient?.patientName ?? '-'}${
                          row.sample.type
                            ? `(${switchGender(row.sample.type)})`
                            : ''
                        }`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: ''
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: ''
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'h3-genetic',
      children: [
        {
          text: `附录：`
        }
      ]
    },
    {
      type: 'h4-genetic-blue',
      children: [
        {
          text: `(一)检测步骤及方法学`
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: `本检测分为全基因组测序文库构建、 突变筛查（运用高通量测序技术）和基因数据分析（运用生物信息学及临
床信息分析技术）三个主要步骤：`
        }
      ]
    },
    {
      type: 'p5',
      children: [
        {
          text: `全基因组测序文库构建：`
        }
      ]
    },
    {
      type: 'p8',
      children: [
        {
          text: `提取DNA，通过随机打断方法构建测序文库`
        }
      ]
    },
    {
      type: 'p5',
      children: [
        {
          text: `突变筛查：`
        }
      ]
    },
    {
      type: 'p8',
      children: [
        {
          text: `构建完成的测序文库采用PE150/PE100测序, 基因组覆盖度不低于99% 。`
        }
      ]
    },
    {
      type: 'p5',
      children: [
        {
          text: `基因数据分析：`
        }
      ]
    },
    {
      type: 'p8',
      children: [
        {
          text: `经过集分子生物学注释、生物学、遗传学及临床特征分析为一体的遗传病精准诊断云平台
系统分析筛选，结合致病突变数据库、正常人基因组数据库、 OMIM数据库及基因数据分析算法，对数百万个基
因变异（含编码区上下游150bp范围内的非编码区变异以及UTR区域变异） 进行分级，变异分级采用三要素分级
体系以及ACMG（美国医学遗传学会）基因变异分级体系。 同时对可能存在的结构变异进行注释分析。`
        }
      ]
    },
    {
      type: 'h4-genetic-blue',
      children: [
        {
          text: `(二)临床特点、适用范围及局限性`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `本项目检测人类全基因组序列、 全外显子组序列，着重分析已知基因的功能序列。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `报告的变异是基于报告时的人类基因外显子序列及变异分类理论体系的认识。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `特定变异的遗传性是基于向实验室描述的家庭关系。非母（源）性或非父（源）性的可能性未被排除。如
果一旦发现，可以报告为非母（源）性或非父（源）性`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `本项目检测的全基因组以及全外显子组序列的覆盖度约为99% 而非百分之百。 因此，如果怀疑特定的临床
疾患/综合征，可能有必要用替代性检测方法对已知基因进行评价。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `二代测序技术不能检测所有变异类型 (见技术特点)。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `检测之前的临床医疗，如骨髓移植和输血，可导致结果的误导。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `本报告中所列示突变未必都会导致受检者发病，是否致病需结合突变影响、遗传方式及临床特征等多因素
综合分析。本报告中与疾病相关性、相关性说明、突变关联疾病及疾病临床特征等信息均来自现有已报道的研
究结果以及数据库信息，均基于我们对医学遗传学的目前的认识水平，无法确保查遍所有文献及跟踪最新文
献，仅供参考。受检者临床特征及临床怀疑疾病均来自医生或患者提供，实验室无法对该信息及基于该信息所
做出的分析结果的真实性、准确性、全面性做出保证。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `一个阳性结果不意味着在这个个体的基因组中没有其它致病性改变。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `一个阴性结果不排除在这个个体的基因组中其它致病变异的存在或提示这个个体的表型没有遗传学病因。
特定变异的临床关联性可能在分析时未知，并在新文献和/或证据发表时需做出改变。`
        }
      ]
    },
    {
      type: 'h4-genetic-blue',
      children: [
        {
          text: `(三)技术特点及局限性`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `本项目检测的全基因组、全外显子组序列的覆盖度约为99% 而非百分之百。覆盖率在样本间、同一样本的基
因间会有差异。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `本报告中所列示结果均为实验室检测数据，仅用于本项目所涉及的人类已知基因全部编码区、非编码区以
及调控区域序列的单碱基转换、颠换和小范围（20bp以内）插入缺失的突变筛查，突变筛查不承诺包含20bp以
上片段的缺失重复、poly结构和串联重复序列等不适合测序技术检测的序列，不包含存在同源相似序列（假基
因）以及存在表观遗传修饰的序列；由于二代短片段测序的局限性，通过WGS测序提示的CNV、SV的准确性存在
局限性，同时实验室也不能承诺检测出所有的CNV和SV。基于二代测序技术的WGS检测即短片段全基因组检测方
法，受到本技术局限性限制，基因组重复区域（串联重复、假基因区域等）、GC异常区域、基因组结构异常区
域（端粒区、着丝粒附近区等）的检测准确性受到影响，难以保障准确性，同时随着技术发展，影响因素包含
但不仅限于以上局限性。在排除以上技术本身局限性影响的情况下，本WGS对SNV和嵌合变异的可识别丰度为5%
以上，可以达到识别1个外显子缺失重复的精度，可以识别包含倒位/易位/融合/单亲二倍体等SV复杂性结构变
异，可以识别5K以上的拷贝数变异，可以识别5% 以上丰度的线粒体变异。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `基因组DNA上检测到的变异未必都能体现在该基因所有mRNA变体序列中。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `不能保证检测到的所有变异都来自父母遗传，有少数变异可能是新生（Denovo）变异，有些可能是来自生
殖细胞嵌合体，也有些变异可能为非遗传性（胚系）变异，即呈现组织异质性的体细胞变异，此类变异有可能
因为在受检组织中的丰度较低而被过滤掉。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `尽管实验室尽最大可能杜绝，仍有很小的可能发生样本或临床信息的混淆，尤其是产生在采样过程中的错
误。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `检测分析前向实验室提供全面、准确的受检者临床特征信息，以及先证者的父母及家系成员是否存在疾病
表型或轻微表型的信息，是非常必要且关键的，错误的临床信息会误导临床分析过程，导致错误的分析结果。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `极少数序列的特殊性或许会干扰Sanger测序技术验证的结果，甚至有些存在同源相似序列（假基因）的变
异无法通过Sanger测序技术验证。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `极少数序列（如基因组重复序列）的特殊性或许会干扰CNV的结果，甚至有些存在同源相似序列（假基因）
的变异无法通过qPCR等技术验证。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `本检测仅针对线粒体DNA突变导致的线粒体遗传病，故报告仅列示与该类疾病可能相关的突变，此类突变一
般为异质性突变（即在样本中突变率小于100% ），且报告中的“样本中突变率”仅限于在本次检测样本组织
（如外周血白细胞）中的突变率，并不等同于受检者的其他组织的突变率。由于线粒体在各组织中的分布存在
异质性和随机性，不同的组织中突变率可能各不相同。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `本检测项目可检测线粒体DNA的点突变和大片段缺失（敏感度为>1kb的片段），且丰度在5% 以上的线粒体变
异。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `本报告中所列示突变未必都会导致受检者发病，是否致病需结合突变影响、遗传方式、临床特征以及其他
检测方法如线粒体酶学检测和医学临床外显子测序项目等综合分析，且线粒体检测结果参考数据库会根据
MITOMAP网站定期更新，但无法保证实时更新，请结合临床综合判断。`
        }
      ]
    },
    {
      type: 'h4-genetic-blue',
      children: [
        {
          text: `(四)基本概念注释`
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `一）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `基因名称：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `即发现突变的基因名称，这里原则上列出的均为NCBI上的官方命名（Official Name）。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `二）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `染色体位置：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `指突变在染色体上的绝对坐标位置，这个位置是唯一的（参考基因组Hg19）。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `三）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `核苷酸改变：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `指检测到的在基因组上和cDNA上的碱基变异。SNV(single nucleotide variants)代表单核
苷酸突变。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `1.点突变（碱基颠换）的核酸改变表示:“c.(c.*/c.-)(数字)(exon*)碱基>碱基”,"c.(c.*/c.-)（数字）+/-
(数字)(IVS*)碱基>碱基",其中c.表示该基因编码区,c.-/c.*表示该基因非编码区的5'UTR/3'UTR位置。
如:1)c.8306(exon10)C>T，即表示：该基因mRNA的编码区8306位的碱基C突变为T,位于第10个外显子。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `2)c.-36G(exon1)>T,即表示:该基因mRNA的5'UTR区距离起始密码第36位的碱基G突变为T,位于第1个外显子。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `3)c.342-1(IVS4)C>A，即表示：该基因mRNA的内含子4的3'端最后1位(即在c.342前1位）的碱基C突变为A。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `2.插入缺失突变位置的核酸改变表示:"c.(c.-/c.*)(数字)(exon*/IVS*)_c.(c.-/c.*)(数字)(exon*/IVS*)插入/
缺失&碱基";如c.10+4(IVS1)_c.10+5(IVS1)insT,即表示:从内含子1的第4位置到第5位置之间插入碱基T;“IVS*
(exon*)”表示突变位于第几内含子(外显子)，比如(IVS15)，则表示突变位于第15内含子。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `四）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `氨基酸改变：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `DNA的突变对氨基酸序列带来的变化。氨基酸是蛋白质的基本组成单位，编码氨基酸的基因序
列发生改变，就可能造成蛋白序列的变化。报告中常见的氨基酸改变主要有以下几种：`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `1.错义突变：DNA的变异导致该位置氨基酸的改变，这类变异叫做错义突变。对于错义，表示为:"p.氨基酸(数
字)氨基酸"，如p.Y856H；即表示：该基因编码的蛋白的第856氨基酸蛋白位置上，氨基酸Y突变为氨基酸H。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `2.无义突变：表示为：“p.氨基酸(数字1)氨基酸,数字2”，这种突变导致数字1位置的氨基酸变为终止密码子
（用X表示），从而导致蛋白的氨基酸序列在此处异常终止；数字2表示该终止突变引起蛋白缩短的长度。
如“p.E364X,216”,即表示该基因的该无义突变导致其编码的蛋白第364位氨基酸之后的216个氨基酸均无法翻
译，从而导致蛋白缩短了216个氨基酸。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `3.剪接位点突变：这种突变会影响DNA的转录过程,导致转录产物mRNA序列的异常,从而导致蛋白结构的异常。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `4.框移突变：也叫做移码突变，是指插入或缺失N个碱基的突变，N为非3的整数倍的数字，这种突变会导致读码
框发生错位，从而导致该位置及之后的蛋白的氨基酸序列的明显改变。表示为：“p.氨基酸（数字1）氨基酸
fs*(数字2)”，fs表示frameshift（移码）。数字2表示从突变氨基酸位置开始算起，后面还可以翻译但框移的
氨基酸的数量。如“p.N80Mfs*6”，即表示该基因的该框移突变导致其编码的蛋白从第80位氨基酸开始算起，
后面再翻译6个氨基酸即终止，且这6个氨基酸是移码的，序列和原来的序列不同。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `5.对于造成蛋白序列长度变化的，如插入缺失突变、框移突变（造成移码的插入缺失）或剪切位点突变等，则
不予列示氨基酸的具体变化，列表中标记为“插入（/缺失）移码（/非移码）”、“剪切位点”。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `6.对于非编码区如UTR或不影响剪接的内含子突变，该栏目标记为“非编码区”。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `五）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `rs编号：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `该变异在dbSNP数据库中的编号。一个突变有无rs号与该突变是否致病没有直接关系。如果无rs编
号提示可能是新发现的突变位点。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `六）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `MAF：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `即次要等位基因频率（Minor Allele Frequency）。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `1.在本报告中，MAF可以通俗理解为该变异的杂合形式在人群中的分布率（出现概率）。如MAF为0.0215，则表
示该变异的杂合形式在人群中的分布率为2.15% 。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `2.MAF数据可以用于区别普通变异和罕见变异。MAF越小就说明群体中突变概率越低，说明是罕见突变；一般以
1% 作为与疾病相关性的判断的边界线，即MAF>1% 时，一般认为不属于罕见疾病的致病突变。但这也不是绝对
的，一方面MAF值是在不断修正的，随着人类基因组数据库的不断扩充，很多变异的MAF都在发生变化；另一方
面，还要结合具体情况分析，比如对于MAF为2% 的纯合变异，该纯合型在人群中出现的概率为2% ×2% =0.04% ，
那就比杂合型罕见多了，就不能简单归为无意义的SNP了。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `七）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `纯合/杂合/半合子：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `杂合是指在由父母遗传来的一对等位基因中，其中一个基因上发现了突变，而另一个
基因序列是正常的。而纯合是指两个等位基因的相同位置上都发现了突变，没有任何一个基因是正常的。对于
常染色体上的突变，纯合突变是一对等位基因都存在突变，而杂合突变指等位基因中只有其中一个基因出现突
变；对于男性的X染色体上的突变，因为只有一个等位基因，因此只有纯合类型（半合子）。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `八）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `ACMG变异分级：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `根据美国医学遗传学和基因组学与分子病理学协会制定的2015测序变异的解读指南进行的
分级。（参考文献：Standards and Guidelines for the Interpretation of Sequence Variants: A
Joint Consensus Recommendation of the American College of Medical Genetics and Genomics and
the Association for Molecular Pathology）`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `九）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `蛋白预测结果：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `根据人类基因组变异软件Provean、SIFT等预测出的基因变异对蛋白结构影响的结果。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `十）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `变异位点相关PubMed文献号：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `该变异与疾病的相关性如在OMIM数据库中有文献报道，则提供PubMed文献
号，根据文献号可以在PubMed数据库中查找相应的文献，需注意的是，文献中所提及的疾病与报告中的基因关
联疾病有可能不尽相同，且OMIM数据库收录文献未必全面及时。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `十一）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `疾病名称：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `本报告中对于与疾病相关性已经明确的基因，则列出该基因关联的疾病名称。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `十二）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `遗传方式：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `指该疾病所呈现的孟德尔遗传方式，分为AD（常染色体显性遗传）、AR（常染色体隐性遗
传）、XD（X染色体显性遗传）、XR（X染色体隐性遗传），共显性遗传、Y染色体遗传、双隐性遗传等。一种疾
病有可能有多种遗传方式。大部分常染色体显性遗传病为不完全显性（ADIP）。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ``
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell',
              children: [{ text: '缩略词' }]
            },
            {
              type: 'table-cell',
              children: [{ text: '英文' }]
            },
            {
              type: 'table-cell',
              children: [{ text: '中文	' }]
            }
          ]
        },
        ...specialInheritance.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p7',
                    children: [
                      {
                        text: row.acronym
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p7',
                    children: [
                      {
                        text: row.en
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'p7',
                    children: [
                      {
                        text: row.zh
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ``
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `十三）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `CNV相关基本概念：`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `1. 细胞遗传学位置：指从细胞遗传学尺度上的位置描述，如15q11-13表示CNV发生在15号染色体的长臂1区1带
到1区3带之间。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `2. 基因组坐标：指CNV在染色体上的绝对坐标位置，这个位置是唯一的（参考基因组Hg19）。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `3.CNV类型&拷贝数：CNV类型是指缺失或重复，拷贝数是指缺失或重复的拷贝的数目。如“缺失1”则表示缺失
了一个拷贝，对于常染色体的而言，等同于“杂合缺失”，即本应有2个拷贝，但受检者只有一个拷贝；“重复
1”则表示增加了一个拷贝，对于常染色体的而言，等同于“单倍重复”，即本应有2个拷贝，但受检者有3个拷
贝；`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `4. 剂量敏感：不是所有基因丢失或增加了拷贝数都会导致疾病，某些特定基因的功能与其基因组拷贝数高度相
关，则被成为“剂量敏感”，若该基因拷贝数异常则会导致疾病；某些基因的功能与其基因组拷贝数相关性不高，则被称为“剂量不敏感”，若该基因出现单倍缺失则未必会导致疾病。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `5. 基因序列中断：如果一个CNV导致某一个基因序列中断，则可能会导致该基因的转录产物的显著变化，对该
基因功能造成显著影响。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `6.CNV/UPD/SV：CNV(Copy number variation)-拷贝数变异，UPD(uniparental disomy)-单亲二倍
体，SV(Structural variation)-基因组结构性变异。`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `十四）`
            }
          ]
        },
        {
          type: 'span-blod',
          children: [
            {
              text: `预期之外发现的变异位点：`
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: `可能与受检者目前的临床表现不相关，但预示未来发病风险。`
            }
          ]
        }
      ]
    },
    {
      type: 'h4-genetic-blue',
      children: [
        {
          text: `(五)质控相关参数说明`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `原始数据产出(Mb):测序下机的原始数据量，即测序得到的碱基数目，以Mb为单位，1Mb=1000000base。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `clean data：过滤掉低质量碱基和低质量reads之后的可靠数据。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `总深度:测序数据在基因组区域的总测序深度。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `平均深度:测序数据在基因组区域的平均测序深度。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `目标区域数据质量Q20:测序数据中质量值>20的碱基的百分比。`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `目标区域数据质量Q30:测序数据中质量值>30的碱基的百分比 (碱基质量值是该碱基测序错误率的体现，质
量值=-10log10(e)，e为该碱基的测序错误率。即碱基质量值为30的时候，这个碱基测错的概率为千分之一，
表明该碱基可靠性非常高)。`
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ``
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          type: 'span-start',
          children: [
            {
              text: `本检测报告依据美国2015年ACMG诊断指南和2018年《临床单基因遗传病基因检测报告规范》制定。`
            }
          ]
        }
      ]
    },
    {
      type: 'h3-genetic',
      children: [
        {
          text: `遗传病简介`
        }
      ]
    },
    {
      type: 'paragraph-color',
      children: [
        {
          type: 'p9',
          children: [
            {
              text: `遗传病，是指遗传物质发生改变所导致的疾病。遗传物质的基本功能单位称为基因，基因存在于染色体上。人类
细胞核中存在23对染色体，包含了大约2万个基因，构成人类基因组。`
            },
            {
              text: `为什么遗传物质的改变会导致遗传病？因为遗传物质决定着性状，正常的遗传物质决定正常的性状，不正常的遗
传物质决定着不正常的性状，即遗传病。`
            },
            {
              text: `遗传物质是怎么决定性状，或生命功能的？人体内决定生命功能最重要的物质是蛋白质，蛋白质的结构和功能由
基因决定，基因是遗传物质的基本功能单位，这一连串的相关性本质上体现着上个世纪生物学最伟大的发现之
一：中心法则。`
            }
          ]
        }
      ]
    },
    {
      type: 'h4-genetic',
      children: [
        {
          text: `遗传病可以分为孟德尔遗传病（或单基因病）和多基因病两大类`
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '遗传物质' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-c2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '疾病类别' }]
                }
              ],
              colSpan: 2
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '遗传方式' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic-r3',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '核基因组'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic-c2',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '多基因遗传病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '复杂'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '易感基因'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '孟德尔遗传病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '染色体病:整倍体异常；微缺失微重复(CNV)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '孟德尔遗传'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '遗传病诊断类检测；三级预防筛查'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '单基因遗传病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '孟德尔遗传'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '孟德尔遗传'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic-c2',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '线粒体遗传病'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '母系遗传'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'mtDNAseq'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'h5-genetic',
      children: [
        {
          text: `孟德尔遗传病：`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `这一类遗传病单纯由遗传因素决定，与环境影响无关或环境影响甚微，且遵循着孟德尔所发现的遗传规
律——分离和自由组合定律，因此称之为孟德尔遗传病。这类疾病，绝大多数是由单一基因的功能异常
所致，所以也称为单基因遗传病。`
        }
      ]
    },
    {
      type: 'h5-genetic',
      children: [
        {
          text: `多基因病：`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `另一类遗传病是由基因与环境共同作用致病的，叫做多基因遗传病，也被称为复杂遗传病。这类遗传病
多为常见病，比如人们熟知的糖尿病、癌症、帕金森病等。多基因病的病因复杂，需要多个基因的变异
结合环境共同作用，单纯一个基因的变异不能完全决定发病，故发现基因变异并不能诊断疾病，目前只
能说是发现了有可能导致疾病的诱因之一，或者带来了遗传易感性。`
        }
      ]
    },
    {
      type: 'h5-genetic',
      children: [
        {
          text: `线粒体遗传病：`
        }
      ]
    },
    {
      type: 'p9',
      children: [
        {
          text: `上述遗传病分类只是对细胞核遗传物质改变的疾病的分类，还有一种遗传病是细胞核外的遗传物质改变
导致的，就是线粒体DNA突变导致的线粒体病，这类疾病遵循母系遗传规律，严格讲不属于经典孟德尔遗
传规律，但由于线粒体DNA上一个基因的功能缺失也会导致疾病，因此也被纳入单基因遗传病的范畴。`
        }
      ]
    },
    {
      type: 'h3-genetic',
      children: [
        {
          text: `参考文献`
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'signature-footer',
      children: [
        {
          text: formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
        }
      ]
    }
  ]
}
